// GENERATED FILE - DO NOT MODIFY
import { SmsMessageModel } from "api/models/company/s-m-s/sms-message-model";
import { SmsResponseModel } from "api/models/company/s-m-s/sms-response-model";
import { PagingInfo } from "api/paging-info";
import BaseProxy from "api/proxies/base-proxy";
import ModelDateTransformer from "api/util/model-date-transformer";
import { autoinject } from "aurelia-framework";
import { ApiHelper } from "helpers/api-helper";
import { HttpClientFactory } from "http-client/http-client-factory";
import { HttpClientRequestConfig } from "http-client/http-client-request-config";

@autoinject()
export class SmsProxy extends BaseProxy {
    constructor(modelDateTransformer: ModelDateTransformer, httpClientFactory: HttpClientFactory, apiHelper: ApiHelper) {
        super(modelDateTransformer, httpClientFactory, apiHelper);
    }

    public async HasValidProvider(dispatchTemplateId: string | null, requestConfig?: HttpClientRequestConfig): Promise<boolean> {
        const uri = this.buildUri(
            "/sms-message/setup",
            null,
            { dispatchTemplateId: (dispatchTemplateId === null || dispatchTemplateId === undefined) ? undefined : dispatchTemplateId }
        );

        const data: boolean = await this.get<boolean>(uri, requestConfig);
        return data;
    }

    public async SendMessage(message: SmsMessageModel | null, requestConfig?: HttpClientRequestConfig): Promise<SmsResponseModel | null> {
        const uri = this.buildUri(
            "/sms-message/send",
            null,
            null
        );

        const data: SmsResponseModel | null = await this.post<SmsMessageModel | null, SmsResponseModel | null>(uri, message, requestConfig);
        this.transformModels(data, "Company.SMS.SmsResponseModel");
        return data;
    }

    public async GetMessagesForCurrentUser(sentDate: Date, filter?: string, pagingInfo?: PagingInfo, requestConfig?: HttpClientRequestConfig): Promise<SmsMessageModel[] | null> {
        const uri = this.buildUri(
            "/sms-message/current-user",
            null,
            { sentDate: (sentDate === null || sentDate === undefined) ? undefined : sentDate.toString(), filter: filter ? filter : undefined, page: (pagingInfo && pagingInfo.page ? pagingInfo.page.toString() : undefined), pagesize: (pagingInfo && pagingInfo.pageSize ? pagingInfo.pageSize.toString() : undefined) }
        );

        const data: SmsMessageModel[] | null = await this.get<SmsMessageModel[] | null>(uri, requestConfig);
        this.transformModels(data, "Company.SMS.SmsMessageModel");
        return data;
    }
}
